<template>
  <v-hover v-slot="{ hover }" :disabled="!allowUpload" :style="`min-height: ${size}px; min-width: ${size}px;`">
    <v-avatar :data-name="user.name"
              :size="size"
              :color="color">
      <template v-if="!hover">
        <v-img v-if="avatarPath"
               :src="avatarPath"
               :alt="user.name" />
        <span v-else :class="`${textColor}--text title`">
          {{ firstLetter | upper }}
        </span>
      </template>
      <reg-upload-button v-show="hover"
                         :multiple="false"
                         :allowed-extensions="allowedExtensions"
                         @files-selected="onImageSelected">
        <template #default="{ selectFiles }">
          <v-btn text
                 icon
                 color="primary"
                 dark
                 @click="selectFiles">
            <v-icon>mdi-file-upload</v-icon>
          </v-btn>
        </template>
      </reg-upload-button>
    </v-avatar>
  </v-hover>
</template>

<script>
import UploadButton from '~sendData/UploadButton.vue'
import { v4 as uuid } from 'uuid'

export default {
  name: 'RegUserAvatar',
  components: {
    'reg-upload-button': UploadButton
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    size: {
      type: Number,
      default: 30
    },
    color: {
      type: String,
      default: 'primary'
    },
    textColor: {
      type: String,
      default: 'white'
    },
    allowUpload: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    allowedExtensions() {
      return ['jpg', 'jpeg', 'png', 'gif']
    },
    firstName() {
      const name = this.user.name && this.user.name.split(' ')
      return (name && name[0]) || ''
    },
    firstLetter() {
      return this.firstName[0]
    },
    avatar() {
      return (this.user.preferences && this.user.preferences.avatar) || {}
    },
    avatarPath() {
      if (this.avatar.fullPath) {
        return this.avatar.fullPath
      }
      return null
    },
    uploadBasePath() {
      return `usersAvatars/${uuid()}_{fileExtension}`
    }
  },
  methods: {
    onImageSelected(files) {
      this.uploader = this.$upload.getUploader({
        multiple: false,
        basePath: this.uploadBasePath,
        sizeLimit: 1024 * 1024 * 2,
        autoStart: true,
        imageUpload: true,
        allowedExtensions: this.allowedExtensions
      })

      this.uploader.$on('upload-complete', this.onImageUploadComplete)

      this.uploader.addFiles(files)
    },
    onImageUploadComplete(payload) {
      this.$emit('change', {
        path: payload.path,
        fullPath: payload.fullPath,
        size: payload.fileSize,
        width: payload.width,
        height: payload.height
      })
    }
  }
}
</script>
